import { Exercise } from "./exerciseService";

/**
 * Helper function that returns the URL to the Cartoonist product of the corresponding exercise.
 * @param exercise 
 * @returns URL that can be used as the value to an href attribute.
 */
export function getCartoonistUrl(exercise: Exercise) {
    return 'https://www.creaza.com/editor/' + exercise.contentId + '?exerciseId=' + exercise.id;
}